export const ProductDetailsShimmer = () => {
  return (
    <div className="bg-white rounded p-4 md:max-w-7xl mx-auto animate-pulse">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4">
        {/* Left Panel (Image) */}
        <div className="md:col-span-1 lg:col-span-4 flex flex-col gap-3">
          <div className="aspect-product-desktop bg-gray-200 rounded"></div>
          <div className="flex gap-2 overflow-x-auto">
            {Array.from({ length: 4 }).map((_, idx) => (
              <div key={idx} className="w-20 h-20 bg-gray-200 rounded"></div>
            ))}
          </div>
        </div>

        {/* Right Panel (Info) */}
        <div className="md:col-span-1 lg:col-span-5 space-y-3">
          <div className="h-6 w-3/4 bg-gray-200 rounded"></div>
          <div className="flex gap-2 items-center">
            <div className="h-6 w-24 bg-gray-200 rounded"></div>
            <div className="h-6 w-16 bg-gray-200 rounded"></div>
            <div className="h-6 w-20 bg-red-200 rounded"></div>
          </div>
          <div className="h-20 bg-gray-200 rounded"></div>
          <div className="h-8 bg-gray-200 rounded"></div>
          <div className="flex gap-2">
            <div className="h-10 w-1/2 bg-gray-200 rounded"></div>
            <div className="h-10 w-1/2 bg-gray-200 rounded"></div>
          </div>
          <div className="h-8 bg-gray-200 rounded w-full"></div>
        </div>

        {/* Delivery & Social Panel */}
        <div className="md:col-span-2 lg:col-span-3 space-y-3">
          <div className="h-16 bg-gray-200 rounded"></div>
          <div className="h-32 bg-gray-200 rounded"></div>
          <div className="h-20 bg-gray-200 rounded"></div>
        </div>
      </div>

      {/* Related Products Shimmer */}
      <div className="mt-5">
        <div className="h-6 w-1/3 bg-gray-200 rounded mb-3"></div>
        <div className="flex gap-4 overflow-x-auto">
          {Array.from({ length: 5 }).map((_, idx) => (
            <div key={idx} className="w-48 h-64 bg-gray-200 rounded"></div>
          ))}
        </div>
      </div>
    </div>
  );
};
